import React, { useState } from "react";
import { FetchJsonReturnType } from "shared/fetch/fetchJson";
import { useFetchJson } from "shared/fetch/useFetchJson";
import { useTranslation } from "shared/i18n/useTranslation";
import { useUniqueId } from "shared/uniqueId/useUniqueId";
import { getQueryStringValue } from "shared/url/getQueryStringValue";
import { useRunOnMount } from "shared/useRunOnMount/useRunOnMount";

interface ResetPasswordType {
  handleSubmit?: (e: React.SyntheticEvent) => void;
  // If handleSubmit is passed, following props won't be used
  handleSuccess?: (response: FetchJsonReturnType<void>) => void;
  handleError?: (response: FetchJsonReturnType<void>) => void;
}

export function ResetPassword({ handleSubmit, handleSuccess, handleError }: ResetPasswordType) {
  const { translate } = useTranslation();
  const { uid: getUniqueId } = useUniqueId("ForgotPassword");
  const [isInvalidUrl, setIsInvalidUrl] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [token, setToken] = useState("");
  const { run, isRunning } = useFetchJson<void>();

  useRunOnMount(() => {
    const emailFromQS = getQueryStringValue("email");
    const tokenFromQS = getQueryStringValue("token");
    if (emailFromQS && tokenFromQS) {
      setEmail(emailFromQS);
      setToken(tokenFromQS);
    } else {
      setIsInvalidUrl(true);
    }
  });

  function handleOnChange(e: React.ChangeEvent<HTMLInputElement>) {
    setPassword(e.target.value);
  }

  async function handleForgotPasswordSubmit(e: React.SyntheticEvent): Promise<void> {
    e.preventDefault();
    try {
      const apiResponse = await run("/auth/api/ResetPassword", {
        method: "post",

        body: {
          password,
          confirmPassword: password,
          userNameOrEmail: email,
          selectedMethod: 0,
          token,
        },
      });
      if (handleSuccess) handleSuccess(apiResponse);
    } catch (error: any) {
      if (handleError) handleError(error);
      else throw error;
    }
  }

  return (
    <form onSubmit={handleSubmit ?? handleForgotPasswordSubmit}>
      <div className="mb-3">
        {isInvalidUrl && (
          <div className="alert alert-danger" role="alert">
            {translate("__urlIsInvalidMakeSureYouCopiedWhole")}
          </div>
        )}
      </div>
      <div className="mb-3">
        <label htmlFor={getUniqueId("email")} className="form-label">
          {translate("__email")}
        </label>
        <input
          type="email"
          className="form-control-plaintext"
          id={getUniqueId("email")}
          onChange={handleOnChange}
          value={email}
        />
      </div>

      <div className="mb-3">
        <label htmlFor={getUniqueId("password")} className="form-label">
          {translate("__password")}
        </label>
        <input
          type="password"
          className="form-control"
          id={getUniqueId("password")}
          onChange={handleOnChange}
          value={password}
        />
      </div>

      <button type="submit" className="btn btn-primary" disabled={isRunning}>
        {translate("__setPassword")}
      </button>
      <a href="login" className={`d-block text-center mt-3 `}>
        {translate("__doYouKnowYourPassword")}
      </a>
    </form>
  );
}
